import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({
        getCallLogs: builder.mutation({
            query: (body) => ({
                url: `call/getCallLogs`,
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),
    })
})

export const { useGetCallLogsMutation } = Api
